import {ApplicationEntity} from "@/model/entity/application-entity"
import {Company} from "@/model/entity/company/company"
import {Country} from "@/model/entity/country/country"
import {FieldDescriptor, FieldTypeEnum} from "@/model/entity//field-descriptor"
import {Type} from "class-transformer"
import { ShipmentReturn } from "../shipment/shipment-return"

export class Office extends ApplicationEntity {
  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.name"})
  officeName: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.street"})
  officeStreet: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.house_number"})
  officeHouseNumber: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.city"})
  officeCity: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.zip"})
  officeZip: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.detail"})
  officeDetail: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.contact_person"})
  officeContactPerson: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.email"})
  officeEmail: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.tel"})
  officeTel: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.business_unit"})
  businessUnit: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.office.sender_id"})
  senderId: string

  lang: string

  homeDepot: string

  reportPageFormat: string

  charset: string

  company?: Company

  reportPageStartPosition?: number

  @Type(() => Country)
  country?: Country

  @Type(() => ShipmentReturn)
  shipmentReturn: ShipmentReturn

  constructor(
    id?: number,
    senderId: string = "",
    officeName: string = "",
    officeStreet: string = "",
    officeHouseNumber: string = "",
    officeCity: string = "",
    officeZip: string = "",
    officeDetail: string = "",
    officeContactPerson: string = "",
    officeEmail: string = "",
    officeTel: string = "",
    businessUnit: string = "",
    lang: string = "EN",
    homeDepot: string = "",
    reportPageFormat: string = "PDF_A4",
    charset: string = "UTF_8",
    country?: Country,
    company?: Company,
    shipmentReturn?: ShipmentReturn
  ) {
    super(id)
    this.officeName = officeName
    this.officeStreet = officeStreet
    this.officeHouseNumber = officeHouseNumber
    this.officeCity = officeCity
    this.officeZip = officeZip
    this.officeDetail = officeDetail
    this.officeContactPerson = officeContactPerson
    this.officeEmail = officeEmail
    this.officeTel = officeTel
    this.businessUnit = businessUnit
    this.country = country
    this.company = company
    this.lang = lang
    this.homeDepot = homeDepot
    this.reportPageFormat = reportPageFormat
    this.charset = charset
    this.reportPageStartPosition = 0
    this.senderId = senderId
    this.shipmentReturn = shipmentReturn
  }
}
